import styled from 'styled-components';
import { Text } from '@bechtel/gds';

export const HeadingStyled = styled(Text).attrs({
  size: '400',
  color: 'grey.1000',
  family: 'graphik',
})`
  padding-top: ${({ theme }) => theme.spacings[100]};
  padding-bottom: ${({ theme }) => theme.spacings[100]};
  white-space: nowrap;
`;
